<template>
  <section
    class="stats-banner-section"
    :style="{ backgroundImage: 'url(/assets/background3.svg)' }"
  >
    <div class="dot-overlay" />
    <v-container style="max-width: 1140px; position: relative; z-index: 1" class="my-10">
      <div class="inner">
        <h2 class="stats-headline">{{ $t('statsBanner.headline') }}</h2>

        <div class="cards-row">
          <div
            v-for="(card, i) in cards"
            :key="i"
            class="stat-card my-16"
            :class="{ 'stat-card--accent': i === 2 }"
            :style="card.color ? { background: card.color } : {}"
          >
            <div class="stat-value" :class="{ 'stat-value--orange': i === 2 }">
              {{ card.stat }}
            </div>
            <p class="stat-desc">{{ card.desc }}</p>
            <div class="stat-brand">{{ card.brand }}</div>
          </div>
        </div>

        <div class="nav-row">
          <button class="nav-btn" aria-label="Previous">
            <v-icon color="white" size="20">mdi-arrow-left</v-icon>
          </button>
          <button class="nav-btn" aria-label="Next">
            <v-icon color="white" size="20">mdi-arrow-right</v-icon>
          </button>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'StatsBanner',
  computed: {
    cards() {
      const val = this.$t('statsBanner.cards')
      return Array.isArray(val) ? val : []
    },
  },
}
</script>

<style scoped>
.stats-banner-section {
  background-color: #171421;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

.dot-overlay {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(255,255,255,0.07) 1px, transparent 1px);
  background-size: 28px 28px;
  pointer-events: none;
  z-index: 0;
}

.inner {
  display: flex;
  flex-direction: column;
}

.stats-headline {
  font-size: 2.8rem;
  font-weight: 900;
  color: #ffffff;
  line-height: 1.15;
  letter-spacing: -1.5px;
  max-width: 560px;
}

@media (max-width: 768px) {
  .stats-headline {
    font-size: 2rem;
    letter-spacing: -0.8px;
  }
}

.cards-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

@media (max-width: 960px) {
  .cards-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .cards-row {
    grid-template-columns: 1fr;
  }
  .stat-card {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
}

.stat-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.stat-card--accent {
  background: rgba(255, 255, 255, 0.09);
  border-color: rgba(255, 255, 255, 0.16);
}

.stat-value {
  font-size: 2.6rem;
  font-weight: 900;
  color: #ffffff;
  letter-spacing: -1.5px;
  line-height: 1;
}

.stat-value--orange {
  color: #ff8c42;
}

.stat-desc {
  font-size: 0.88rem;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.65;
  margin: 0;
  flex: 1;
}

.stat-brand {
  font-size: 0.78rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.35);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 8px;
}

.nav-row {
  display: flex;
  gap: 12px;
}

.nav-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.nav-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.4);
}
</style>
